export default
[
  {
    "day": "Chest, Triceps, & Abs",
    "image": "/assets/exercise-photos/home-chest.jpg",
    "exercises": [
      "home-warmup",
      "standard-pushup",
      "decline-pushup",
      "incline-pushup",
      "chair-dip",
      "overhead-dumbbell-extension",
      "russian-twist",
      "spiderman-plank",
      "side-plank"
    ]
  },
  {
    "day": "Legs",
    "image": "/assets/exercise-photos/home-legs.jpg",
    "exercises": [
      "home-warmup",
      "air-squat",
      "bodyweight-lunge",
      "goblet-squat",
      "lunge-to-high-knee",
      "wall-sit",
      "glute-bridge",
      "donkey-kick",
      "home-calf-raise",
    ]
  },
  {
    "day": "Back & Biceps",
    "image": "/assets/exercise-photos/home-back.jpg",
    "exercises": [
      "home-warmup",
      "wide-grip-pullup",
      "underhand-pullup",
      "bent-over-resistance-band-row",
      "reverse-dumbbell-fly",
      "lower-back-curl",
      "resistance-band-lateral-raise",
      "resistance-band-curl"
    ]
  },
  {
    "day": "Shoulders & Abs",
    "image": "/assets/exercise-photos/home-shoulders.jpg",
    "exercises": [
      "dumbbell-lateral-raise",
      "dumbbell-front-raise",
      "dumbbell-shoulder-press",
      "hanging-leg-raise",
      "high-knees",
      "plank",
      "bicycle-crunch"
    ]
  }
]



//////////////////
// WEBPACK FOOTER
// ./src/providers/plan/home-plan.js
// module id = 255
// module chunks = 6